import React, { type FC } from 'react';
import { Destination, SizeType } from 'reactApp/ui/DataListItemCommonComponents/Destination/Destination';
import { NoAccessItem } from 'reactApp/ui/DataListItemRow/components/NoAccessItem/NoAccessItem';

interface ItemDestinationProps {
    path: string;
    isCompact?: boolean;
    isAccessDenied: boolean;
}

export const ItemDestination: FC<ItemDestinationProps> = ({ path, isCompact, isAccessDenied }) => {
    if (isAccessDenied) {
        return <NoAccessItem hideName />;
    }

    return isCompact ? <Destination destination={path} size={SizeType.s} noMargin /> : <Destination destination={path} />;
};
